import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { TaskStatus } from '@/interfaces/server-data';

@Component
export default class TaskStatusMixin extends Vue {
  getTaskStatusClass(status: TaskStatus, revaluationStatus: TaskStatus): string {
    if (status === TaskStatus.APPROVED) {
      return 'greenMessageText';
    }
    if (status === TaskStatus.REJECTED) {
      return 'redMessageText';
    }
    if (status === TaskStatus.PARTIALLY_APPROVED
        || status === TaskStatus.PARTIALLY_REJECTED
        || revaluationStatus === TaskStatus.PARTIALLY_APPROVED
        || revaluationStatus === TaskStatus.PARTIALLY_REJECTED
    ) {
      return 'task-status-partial';
    }
    return 'task-status-default';
  }
}


